<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading.general" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading.general && records.length">
          <div v-if="false" class="text-right mb-1">
            <LoadingButton
              title='Поиск нового отправления'
              className="btn btn-outline-info"
              :onClick="() => newTask()"
              :loading="loading.btn.newTask"
              type="button"
              :color="$constants.LOADING_COLOR"
            />
          </div>
          <table class="table mt-0 table-sm table-hover">
            <thead>
            <tr>
              <th width="70px"></th>
              <th></th>
              <th width="100px">ссылка</th>
              <th width="100px">стикер</th>
              <th width="100px">Дата</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(r,i) in records">
              <tr>
                <td :rowspan="r.records.length + 1">
                  {{ (i + 1) + ((paginator?.current_page ?? 1) - 1) * (paginator?.per_page ?? 1) }}
                </td>
                <td class="p-0 border-0"/>
                <td class="p-0 border-0"/>
                <td :rowspan="r.records.length + 1">
                  <LoadingButton
                    title='Скачать'
                    className="btn btn-outline-success"
                    :onClick="() => generate(r)"
                    :loading="loading.btn[r.id]"
                    type="button"
                    :color="$constants.SUCCESS_COLOR"
                  />
                </td>
                <td :rowspan="r.records.length + 1">{{ printDate(r.created_at) }}</td>
              </tr>
              <tr v-for="f in r.records">
                <td>
                  <p>{{ f.orderNumber }} ({{ f.orderDate }}) {{ f.cityFrom.name }} -> {{ f.cityTo.name }}</p>
                </td>
                <td>
                  <a
                    :href="`https://www.cdek.ru/ru/tracking?order_id=${f.orderNumber}`"
                    target="_blank">track online</a>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      ref="Pagination"
                      :page-range="11"
                      :margin-pages="2"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  title: 'Стикеры для накладных',
  components: {LoadingButton, Paginate},
  data() {
    return {
      records: [],
      paginator: null,
      loading: {
        general: false,
        btn: {
          newTask: false,
        }
      },
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async newTask() {
      this.loading.btn.newTask = true;
      const {data} = await api.post('/tasks/new', {
        type: 'transit_stickers'
      });
      if (data.success) {
        toastr['success']('Задача создана', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.btn.newTask = false;
    },
    async generate(record) {
      // console.log(record);
      this.$set(this.loading.btn, record.id, true);
      const {data} = await api.index('new/files/download/' + record.id);
      if (data.success) {
        window.location.href = data.link;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки файла');
      }
      this.$set(this.loading.btn, record.id, false);
    },
    async getRecords(page = 1) {
      this.loading.general = true;
      // let {data: r_data} = await api.index('/tasks/type/32?page=' + page);
      let {data: r_data} = await api.index('new/files/byType/4?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        const records = data.reduce((acc, r) => {
          acc[r.id] = {
            id: r.id,
            created_at: r.created_at,
            records: [],
            invoices: r?.details?.file_generate_data?.invoices
          };
          (r?.details?.file_generate_data?.body ?? [r?.details?.file_generate_data]).forEach((c) => {
            acc[r.id].records.push({
              orderNumber: c.data.orderNumber,
              orderDate: c.data.orderDate,
              cityFrom: {
                name: c.data.cityFrom.name
              },
              cityTo: {
                name: c.data.cityTo.name
              }
            })
          });
          return acc;
        }, {});
        this.records = _.orderBy(Object.values(records), 'id', 'desc');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.general = false;
    }
  }
}

</script>
